import PublicChangelog from '@/docs/PUBLIC_CHANGELOG.md?raw';
import { usePageTitle } from '@/hooks/usePageTitle';
import { createUseStyles } from '@/services/createUseStyles';
import { Box, Paper } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const useStyles = createUseStyles(theme => ({
  ChangelogPage_root: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    padding: '24px',
    borderRadius: '12px',
  },
  ChangelogPage_Container: {
    maxWidth: 950,
    width: '100%',
    padding: '0 32px 64px',
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    borderRadius: 8,
    overflow: 'auto',
    height: '100%',

    '& h1, & h2, & h3, & h4': {
      fontWeight: 700,
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    '& ul': {
      paddingLeft: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    '& li': {
      marginBottom: theme.spacing(1),
      fontSize: '1rem',
    },
    '& p': {
      marginBottom: theme.spacing(2),
      fontSize: '1.05rem',
    },
    '& hr': {
      margin: theme.spacing(3, 0),
      border: 0,
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    '& strong': {
      color: theme.palette.primary.main,
    },
  },
}));

export default function ChangelogPage() {
  const c = useStyles();

  usePageTitle('Change Log');

  return (
    <Box className={c.ChangelogPage_root}>
      <Paper className={c.ChangelogPage_Container} elevation={2}>
        <ReactMarkdown>{PublicChangelog}</ReactMarkdown>
      </Paper>
    </Box>
  );
}
